import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { GamesService } from 'core/services/games.service';
import { Game } from 'core/models/game';
import { lastValueFrom } from 'rxjs';

export const GameResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  gamesService: GamesService = inject(GamesService)
): Promise<Game> => {
  const group = route.parent.data.group;
  if (!group || group.type === 'itinerary') return null;

  return lastValueFrom(gamesService.getGame(group.gameId))
    .then((game) => {
      return game;
    })
    .catch(() => {
      return null;
    });
};
